var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import isArray from 'lodash/isArray';
import omit from 'lodash/omit';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { StyledButton } from './style';
var imagePlaceholder = require('./img/image_thumb_placeholder.svg');
var ExtendButton = /** @class */ (function (_super) {
    __extends(ExtendButton, _super);
    function ExtendButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtendButton.prototype.componentDidMount = function () {
        if (this.props.coverType === 'image' && this.props.cover) {
            var imgSrc_1 = new Image();
            var divElement_1 = ReactDOM.findDOMNode(document.getElementsByClassName('gradient')[0]);
            imgSrc_1.onload = function () {
                var bgImageSrc = imgSrc_1 ? imgSrc_1.src : imagePlaceholder;
                if (divElement_1) {
                    divElement_1.style.backgroundImage = 'url(' + bgImageSrc + ')';
                }
            };
            imgSrc_1.src = this.props.cover;
        }
    };
    ExtendButton.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.coverType !== this.props.coverType
            && isArray(this.props.cover)
            && this.props.coverType !== 'image') {
            var divElement = ReactDOM.findDOMNode(document.getElementsByClassName('gradient')[0]);
            if (divElement) {
                divElement.style.backgroundImage = '';
            }
        }
    };
    ExtendButton.prototype.render = function () {
        var props = omit(this.props, [
            'cover',
            'coverType',
            'danger',
            'fullWidth',
            'info',
            'outline',
            'transparent',
            'upload',
        ]);
        return React.createElement(StyledButton, __assign({}, props));
    };
    return ExtendButton;
}(React.Component));
export default ExtendButton;
//# sourceMappingURL=button.js.map